import { pushNotification } from "../../pushNotification";

const defaultFilename = "ai-code-metrics-source.tar.gz";

export function aiCodeMetricsOtp(args) {
  const { downloadUrl } = args || {};

  const handleHttpError = (status) => {
    if (status === 404) {
      pushNotification({
        title: "Link expired or invalid",
        desc: "This link has expired or is invalid. Please request a new link.",
        success: false,
      });
    } else if (status === 401) {
      pushNotification({
        title: "Email does not match",
        desc: "The email you entered does not match the email this link was sent to.",
        success: false,
      });
    } else if (status === 403) {
      pushNotification({
        title: "Not authorized",
        desc: "You are not permitted to download the source code.",
        success: false,
      });
    } else {
      pushNotification({
        title: "Error",
        desc: "Something went wrong while downloading the source code. Please try again.",
        success: false,
      });
    }
  };

  return {
    email: "",
    downloading: false,

    async download() {
      const email = this.email.trim();
      if (!email) {
        return;
      }

      this.downloading = true;

      try {
        const response = await fetch(downloadUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRF-Token": document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content"),
          },
          body: new URLSearchParams({ email }),
        });

        if (!response.ok) {
          handleHttpError(response.status);
          this.downloading = false;
          return;
        }

        const blob = await response.blob();
        const disposition = response.headers.get("Content-Disposition") || "";
        const filenameMatch = disposition.match(/filename=(.+)/);
        const filename = filenameMatch
          ? filenameMatch[1].trim()
          : defaultFilename;
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(objectUrl);
      } catch (err) {
        this.downloading = false;
        handleHttpError();
      }
    },
  };
}
